<template>
  <header>
    <div class="nav-left">
      <span class="iconku icon ku-xiangzuo1" @click="backRouter"></span>
      <span class="ku-shuaxin iconku icon" @click="reload"></span>
      <span class="inp">
        <input type="text" :placeholder="word" @blur="onBlur" @focus="onFocus" v-model="searchWord"
               @keydown.enter="getValue" @input="getKey">
        <span class="ku-sousuo iconku icon"></span>
        <div class="history" v-if="isShow">
          <div class="his-left">
            <div class="his-h">大家都在搜</div>
            <ul class="his-list">
              <li v-for="(item,index) in searchList" :key="index"
                  @click="toSearchView(item.indexOf('=') != -1 ? item.split('=')[1].split('SNUM')[0] : item)">
                {{ item.indexOf('=') != -1 ? item.split('=')[1].split('SNUM')[0] : item }}</li>
            </ul>
          </div>
          <div class="his-right">
             <div class="his-h el-flex"><span>搜索历史</span><span class="clear" @click="clearHistory">清空</span></div>
            <div class="his-list" v-if="historyList.length==0">
              <Nodata msg="暂无搜索历史记录"></Nodata>
            </div>
             <ul class="his-list" v-else>
              <li v-for="(item,index) in historyList" :key="index"
                  @click="toSearchView(item)">
                {{  item }}</li>
            </ul>
          </div>
        </div>
      </span>
      <span class="iconku icon ku-tinggeshiqu"></span>
    </div>
    <div class="nav-right">
      <span class="iconku icon ku-qiandaoicon"></span>
      <span class="iconku icon ku-24gl-headphones"></span>
      <span class="iconku icon ku-xiaoxi"></span>
      <span class="iconku icon ku-huanfu"></span>
      <span class="iconku icon ku-shezhi"></span>
      <span class="line">|</span>
      <span class="iconku icon ku-fenxiang"></span>
      <span class="iconku icon ku-jian"></span>
      <span class="iconku icon ku-24gl-minimize"></span>
      <span class="iconku icon ku-guanbi"></span>
    </div>
  </header>
</template>

<script setup>
import Nodata from '@/components/nodata'
import {useRouter, useRoute} from 'vue-router'
import {getSearchKey} from "@/http/api";
import {ref, computed, watch,nextTick} from "vue";
import {storeToRefs} from "pinia";
import useHistoryStore from "@/store/modules/history";
const $router = useRouter()
const $route = useRoute()
const HistoryStore = useHistoryStore()
let {historyList} = storeToRefs(HistoryStore)

let isShow = ref(false)
let searchWord = ref('')
const clearHistory = () => {
  HistoryStore.removeHistoryList()
}
const getValue = () => {
  if (searchWord.value == $route.query.key || searchWord.value == '') return
  $router.push({name: 'searchView', query: {key: searchWord.value}})
  HistoryStore.addHistoryList(searchWord.value)
}
const getKey=(e)=>{
  getData(e.target.value)
}
let searchList = ref([])
const backRouter = () => {
  // $router.back()
  // window.location.reload()
}
const reload = () => {
  // window.location.reload()
}
const getData = async (key) => {
  let result = await getSearchKey(key)
  searchList.value = result.data.data
}
let keyword = computed(() => $route.query.key)
let word = ref('')
watch(() => keyword.value, (newVal) => {
  if (newVal) {
    word.value = newVal
  } else {
    word.value = '搜索音乐/MV/歌单/歌手'
  }
}, {immediate: true})
const onBlur = () => {
  searchWord.value = ''
  setTimeout(() => {
    isShow.value = false
  }, 150)
}
const onFocus = () => {
  if (word.value == '' || word.value == '搜索音乐/MV/歌单/歌手') {
    isShow.value = true
    getData('')
  } else {
    searchWord.value = word.value
    isShow.value = true
    getData(word.value)
  }
}
const toSearchView = (item) => {
  HistoryStore.addHistoryList(item)
  $router.push({name: 'searchView', query: {key: item.trim()}})
}
</script>

<style scoped lang="scss">
header {
  height: 50px;
  padding: 15px 20px;
  display: flex;
  position: fixed;
  top: 0;
  width: calc(100% - 200px);
  background-color: #fff;
  z-index: 9998;
  justify-content: space-between;

  .nav-left {
    display: flex;
    align-items: center;

    .iconku {
      text-align: center;
      color: #7b7b7b;
      margin: 0 5px;
      cursor: pointer;
    }

    .ku-xiangzuo1 {
      font-size: 15px;
    }

    .ku-tinggeshiqu {
      font-size: 18px;
    }

    .inp {
      padding: 5px;
      width: 240px;
      height: 28px;
      margin: 0 5px;
      position: relative;
      border-radius: 15px;
      display: flex;
      align-items: center;
      background-color: #e8e8e8;

      .ku-sousuo {
        position: absolute;
        top: 5px;
        right: 8px;
      }

      input {
        width: 100%;
        text-indent: 1em;
        border: none;
        background-color: #e8e8e8;
      }

      .history {
        position: absolute;
        left: 0px;
        top: 40px;
        padding: 10px;
        width: 490px;
        height: 400px;
        display: flex;
        border-radius: 5px;
        border: 1px solid #f2f2f2;
        background-color: #ffffff;

        .his-h {
          font-size: 14px;
          padding: 10px;
          border-bottom: 1px solid #f2f2f2;
        }

        .his-list {
          padding: 0px 5px;

          :deep(.inner ) {
            img {
              width: 200px;
            }

            .tip {
              font-size: 14px;
            }
          }


          li {
            cursor: default;
            font-size: 14px;
            padding: 8px 0;
            &:hover {
              background-color: #f5f5f5;
            }
          }
        }

        .his-left {
          flex: 1;
          border-right: 1px solid #f2f2f2;
        }

        .his-right {
          flex: 1;
          .el-flex{
            justify-content: space-between;
            .clear{
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .nav-right {
    display: flex;
    align-items: center;

    .ku-qiandaoicon, .ku-xiaoxi, .ku-huanfu, .ku-jian {
      font-size: 20px;
    }

    .ku-qiandaoicon {
      color: #f68514;
    }

    .line {
      color: #dbdbdb;
    }

    span {
      margin: 0 10px;
    }
  }
}
</style>
